import gql from 'graphql-tag';

export default gql`
  mutation updateComparisonCampsites( $comparisonCampsites: String ) {
    updateComparisonCampsites(
      comparisonCampsites: $comparisonCampsites
    ) @client
  }
`;
